import { useState, useEffect } from "react";
import { Trash2, Eye, Mail, Phone, Calendar } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("mv_admin_token")}` } });

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [selected, setSelected] = useState(null);

  const loadContacts = () => {
    axios.get(`${API}/admin/contacts`, authHeaders()).then((r) => setContacts(r.data)).catch(() => toast.error("Errore nel caricamento"));
  };

  useEffect(() => { loadContacts(); }, []);

  const markRead = async (id) => {
    await axios.put(`${API}/admin/contacts/${id}/read`, {}, authHeaders());
    loadContacts();
  };

  const deleteContact = async (id) => {
    if (!window.confirm("Eliminare questo contatto?")) return;
    await axios.delete(`${API}/admin/contacts/${id}`, authHeaders());
    toast.success("Contatto eliminato");
    if (selected?.id === id) setSelected(null);
    loadContacts();
  };

  return (
    <div data-testid="admin-contacts">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        {/* List */}
        <div className="lg:col-span-3 bg-white border border-zinc-200">
          <div className="px-6 py-4 border-b border-zinc-200">
            <h2 className="font-heading text-sm font-bold uppercase tracking-widest text-[#09090B]">
              Messaggi Ricevuti ({contacts.length})
            </h2>
          </div>
          <div className="divide-y divide-zinc-100 max-h-[70vh] overflow-y-auto">
            {contacts.length === 0 ? (
              <p className="p-6 text-zinc-500 text-sm">Nessun messaggio</p>
            ) : (
              contacts.map((c) => (
                <div
                  key={c.id}
                  onClick={() => { setSelected(c); if (!c.read) markRead(c.id); }}
                  className={`px-6 py-4 cursor-pointer hover:bg-zinc-50 transition-colors ${
                    selected?.id === c.id ? "bg-[#FF5200]/5 border-l-4 border-l-[#FF5200]" : ""
                  } ${!c.read ? "bg-blue-50/50" : ""}`}
                  data-testid={`contact-row-${c.id}`}
                >
                  <div className="flex items-center justify-between mb-1">
                    <div className="flex items-center gap-2">
                      {!c.read && <span className="w-2 h-2 bg-blue-500 rounded-full" />}
                      <p className="font-bold text-sm text-[#09090B]">{c.name}</p>
                    </div>
                    <span className="text-xs text-zinc-400">
                      {new Date(c.created_at).toLocaleDateString("it-IT")}
                    </span>
                  </div>
                  <p className="text-sm text-zinc-500 truncate">{c.message}</p>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Detail */}
        <div className="lg:col-span-2">
          {selected ? (
            <div className="bg-white border border-zinc-200" data-testid="contact-detail">
              <div className="px-6 py-4 border-b border-zinc-200 flex items-center justify-between">
                <h3 className="font-heading text-sm font-bold uppercase tracking-widest">Dettaglio</h3>
                <button
                  onClick={() => deleteContact(selected.id)}
                  className="p-2 text-red-500 hover:bg-red-50 rounded-sm transition-colors"
                  data-testid="contact-delete-btn"
                >
                  <Trash2 size={16} />
                </button>
              </div>
              <div className="p-6 space-y-4">
                <div>
                  <p className="text-2xl font-bold text-[#09090B]">{selected.name}</p>
                </div>
                <div className="flex items-center gap-2 text-sm text-zinc-600">
                  <Mail size={14} className="text-[#FF5200]" />
                  <a href={`mailto:${selected.email}`} className="hover:text-[#FF5200]">{selected.email}</a>
                </div>
                {selected.phone && (
                  <div className="flex items-center gap-2 text-sm text-zinc-600">
                    <Phone size={14} className="text-[#FF5200]" />
                    <a href={`tel:${selected.phone}`} className="hover:text-[#FF5200]">{selected.phone}</a>
                  </div>
                )}
                <div className="flex items-center gap-2 text-sm text-zinc-400">
                  <Calendar size={14} />
                  {new Date(selected.created_at).toLocaleString("it-IT")}
                </div>
                <div className="border-t border-zinc-200 pt-4">
                  <p className="text-sm font-bold tracking-widest uppercase text-zinc-500 mb-2 font-heading">Messaggio</p>
                  <p className="text-zinc-700 whitespace-pre-wrap leading-relaxed">{selected.message}</p>
                </div>
                <div className="flex gap-2 pt-2">
                  <a
                    href={`mailto:${selected.email}?subject=Re: Messaggio da mvtrasporti.com`}
                    className="inline-flex items-center gap-2 bg-[#FF5200] text-white px-4 py-2 text-sm font-bold uppercase tracking-wide rounded-sm hover:bg-[#e64a00] transition-colors"
                  >
                    <Mail size={14} /> Rispondi
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-white border border-zinc-200 p-12 text-center">
              <Eye size={40} className="text-zinc-300 mx-auto mb-4" />
              <p className="text-zinc-500">Seleziona un messaggio per vederne i dettagli</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
